import React from 'react';
import PropTypes from 'prop-types';
import { connect, Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import 'bootstrap/dist/css/bootstrap.css';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { MsalProvider } from '@azure/msal-react';
import '../../scss/app.scss';
import Router from './Router';
import store from './store';
import ScrollToTop from './ScrollToTop';
import { config as i18nextConfig } from '../../translations';
import { ProvideAuth } from '../../shared/components/auth/withAuth';
import history from '../../utils/history';
import { msalInstance } from '../../utils/auth/oauth';

i18n.init(i18nextConfig);

const ThemeComponent = ({ children, themeName }) => {
  const theme = createMuiTheme({
    palette: {
      type: themeName === 'theme-dark' ? 'dark' : 'light',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
};

ThemeComponent.propTypes = {
  children: PropTypes.shape().isRequired,
  themeName: PropTypes.string.isRequired,
};

const ConnectedThemeComponent = connect(state => ({ themeName: state.theme.className }))(ThemeComponent);

const App = () => (
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <ProvideAuth>
        <BrowserRouter basename="/">
          <I18nextProvider i18n={i18n}>
            <ScrollToTop>
              <ConnectedThemeComponent>
                <Router history={history} />
              </ConnectedThemeComponent>
            </ScrollToTop>
          </I18nextProvider>
        </BrowserRouter>
      </ProvideAuth>
    </Provider>
  </MsalProvider>
);

export default App;
